import { gql } from "@apollo/client"
export const GET_COMPANY_LOCATIONS = gql`
query GetCompanyLocations ($companyId:UUID!,$query: String, $first: Int, $after: String, $status:String){
  locationsByCompanyId(companyId:$companyId,query: $query, first: $first, after: $after, status:$status) {
  totalCount  
  pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges{
      cursor
      node {
        id
        name
        postalCode
        streetLineOne
        streetLineTwo
        city
        state
        country
        status
        customFields{
          id
          name
          type
          required
          description
        }
        totalStudents
        totalStaff
      }
    }
  }
}
`;